export interface DefaultTheme {
  colors: {
    // Dark Shades
    colorBlack1a: string
    colorBlack29: string
    color292929: string
    color2d3139: string
    color2d3238: string
    color2e384d: string

    // Gray Shades
    color545e6c: string
    color545e6c59: string
    color565e6b: string
    color5a6a7e: string
    color6a7380: string
    color6b7786: string
    color8191a5: string
    color9ba8ba: string
    colora7abb2: string
    colora8abb1: string
    colorb2b5ca: string
    colorb9c2ce: string
    colorbabac0: string
    colorBCC9D9: string
    colorc4c4c4: string

    // Light Shades
    colord4d9de: string
    colord6dade: string
    colord9d9d9: string
    colorDCE3ED: string
    colorddee1e7: string
    colordfe3e8: string
    colore0e3e7: string
    colore4e8ef: string
    colore5e9f1: string
    colore6ebf1: string
    colore9ecf3: string
    colore9edf2: string
    colorebebeb: string
    coloreceff4: string
    colorf1f4f6: string
    colorf2f4f5: string
    colorf2f4f6: string
    colorf2f7ff: string
    colorf3f5f9: string
    colorf4f6f8: string
    colorf5f5f5: string
    colorf5f8fa: string
    colorf7f9fc: string

    // Blue Shades
    color122d52: string
    color00559766: string
    color005597: string
    color1060CC: string
    color1f6ecd: string
    color257ce5: string
    color378ff7: string
    color2196f3: string
    color3A9FC5: string
    color21C7DA: string
    color37D9F7: string
    color5be1f6: string

    // Green Shades
    color198754: string
    color3AC5B5: string
    color37F737: string
    colorA9C53A: string
    colorB7CC10: string
    color4CAF50: string
    colorF7DD37: string

    // Orange Shades
    color533f03: string
    color856404: string
    colorc5683a: string
    colorC58A3A: string
    colorC5B73A: string
    colorF76337: string
    colorFFB324: string
    colorFF8729: string

    // Red Shades
    colorcd1f1f: string
    colorff0000: string
    colorFF2424: string
    colorEB0052: string
    colorEA5DA9: string

    // Purple Shades
    color923AC5: string

    // Yellow Shades
    colorffeeba: string
    colorfff3cd: string
    colorFFE2E2: string
    colorFFE9E9: string

    // Sky Blue Shades
    colord3e6fb: string

    // Mint Green Shades
    colord4edda: string
    colorE3FFE2: string
    colore6f4e7: string
  }
  responsiveSize: {
    // string ex.: '320px'
    big: string
    tablet: string
    bigTablet: string
    // number ex.: '320'
    numberBig: number
  }
}

export interface IPropsTheme {
  theme: DefaultTheme
}

export const theme: DefaultTheme = {
  colors: {
    // Dark Shades
    colorBlack1a: '#0000001a',
    colorBlack29: '#00000029',
    color292929: '#292929',
    color2d3139: '#2d3139',
    color2d3238: '#2d3238',
    color2e384d: '#2e384d',

    // Gray Shades
    color545e6c: '#545e6c',
    color545e6c59: '#545e6c59',
    color565e6b: '#565e6b',
    color5a6a7e: '#5a6a7e',
    color6a7380: '#6a7380',
    color6b7786: '#6b7786',
    color8191a5: '#8191a5',
    color9ba8ba: '#9ba8ba',
    colora7abb2: '#a7abb2',
    colora8abb1: '#a8abb1',
    colorb2b5ca: '#b2b5ca',
    colorb9c2ce: '#b9c2ce',
    colorbabac0: '#babac0',
    colorBCC9D9: '#BCC9D9',
    colorc4c4c4: '#c4c4c4',

    // Light Shades
    colord4d9de: '#d4d9de',
    colord6dade: '#d6dade',
    colord9d9d9: '#d9d9d9',
    colorDCE3ED: '#DCE3ED',
    colorddee1e7: '#dee1e7',
    colordfe3e8: '#dfe3e8',
    colore0e3e7: '#e0e3e7',
    colore4e8ef: '#e4e8ef',
    colore5e9f1: '#e5e9f1',
    colore6ebf1: '#E6EBF1',
    colore9ecf3: '#e9ecf3',
    colore9edf2: '#e9edf2',
    colorebebeb: '#ebebeb',
    coloreceff4: '#eceff4',
    colorf1f4f6: '#f1f4f6',
    colorf2f4f5: '#f2f4f5',
    colorf2f4f6: '#f2f4f6',
    colorf2f7ff: '#f2f7ff',
    colorf3f5f9: '#f3f5f9',
    colorf4f6f8: '#f4f6f8',
    colorf5f5f5: '#f5f5f5',
    colorf5f8fa: '#f5f8fa',
    colorf7f9fc: '#f7f9fc',

    // Blue Shades
    color122d52: '#122d52',
    color00559766: '#00559766',
    color005597: '#005597',
    color1060CC: '#1060CC',
    color1f6ecd: '#1f6ecd',
    color257ce5: '#257ce5',
    color378ff7: '#378ff7',
    color2196f3: '#2196f3',
    color3A9FC5: '#3A9FC5',
    color21C7DA: '#21C7DA',
    color37D9F7: '#37D9F7',
    color5be1f6: '#5be1f6',

    // Green Shades
    color198754: '#198754',
    color3AC5B5: '#3AC5B5',
    color37F737: '#37F737',
    color4CAF50: '#4CAF50',
    colorA9C53A: '#A9C53A',
    colorB7CC10: '#B7CC10',
    colorF7DD37: '#F7DD37',

    // Orange Shades
    color533f03: '#533f03',
    color856404: '#856404',
    colorc5683a: '#c5683a',
    colorC58A3A: '#C58A3A',
    colorC5B73A: '#C5B73A',
    colorF76337: '#F76337',
    colorFFB324: '#FFB324',
    colorFF8729: '#FF8729',

    // Red Shades
    colorcd1f1f: '#cd1f1f',
    colorff0000: '#ff0000',
    colorFF2424: '#FF2424',
    colorEB0052: '#EB0052',
    colorEA5DA9: '#EA5DA9',

    // Purple Shades
    color923AC5: '#923AC5',

    // Yellow Shades
    colorffeeba: '#ffeeba',
    colorfff3cd: '#fff3cd',
    colorFFE2E2: '#FFE2E2',
    colorFFE9E9: '#FFE9E9',

    // Sky Blue Shades
    colord3e6fb: '#d3e6fb',

    // Mint Green Shades
    colord4edda: '#d4edda',
    colorE3FFE2: '#E3FFE2',
    colore6f4e7: '#e6f4e7'
  },
  responsiveSize: {
    big: '414px',
    tablet: '768px',
    bigTablet: '1024px',
    // number version
    numberBig: 414
  }
}
